var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgArrow = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 49,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#2C3E50",
  fillRule: "evenodd",
  d: "M7.94 15.887a1.5 1.5 0 0 1 2.12 0L24 29.826l13.94-13.94a1.5 1.5 0 0 1 2.12 2.122L24 34.068 7.94 18.009a1.5 1.5 0 0 1 0-2.121Z",
  clipRule: "evenodd"
})));
export default SvgArrow;